import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/adminPage";
import SettingsPage from "./pages/SettingsPage";
import ConnectPage from "./pages/ConnectPage";
import FAQ from "./pages/FAQpage";
import ForgottenPassword from "./pages/ForgotPasswordPage";
import SignupPage from "./pages/SignupPage";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import {store} from "./store"
import { ChakraProvider } from "@chakra-ui/react";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/loginPage",
    element: <LoginPage />,
  },
  {
    path: "/signupPage",
    element: <SignupPage />,
  },
  {
    path: "/settingsPage",
    element: <SettingsPage />,
  },
  {
    path: "/connectPage",
    element: <ConnectPage />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/forgotpassword",
    element: <ForgottenPassword />,
  },
  
  
]);


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <div className="App">
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
      </div>
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
